import { LoadingModalProps, RMModalProps } from '.';

export const enum ModalType {
  Loading,
  Alert,
}
interface _LoadingModalProps extends LoadingModalProps {
  type: ModalType.Loading;
}

interface _AlertModalProps extends RMModalProps {
  type: ModalType.Alert;
}

export type ModalProps = _LoadingModalProps | _AlertModalProps;

export const defaultLoadingModalState: ModalProps = {
  type: ModalType.Loading,
  showModal: false,
  text: '',
};

export const defaultAlertModalState: ModalProps = {
  type: ModalType.Alert,
  body: '',
  heading: '',
  showModal: false,
  setShowModal: () => {},
};
